import React__default from "react";
const useHorizontalScroll = ({ containerRef, elementsRef }) => {
  const scrollTo = React__default.useCallback(
    (direction) => {
      const container = containerRef.current;
      const elements = elementsRef.current;
      if (!container || !elements) {
        return;
      }
      const children = elements.filter((e) => e !== null);
      const visibleIndices = getVisibleIndices(container, elements);
      const currentScrollRightIndex = visibleIndices[visibleIndices.length - 1];
      const currentScrollLeftIndex = visibleIndices[0];
      let nextScrollIndex = direction === "right" ? currentScrollRightIndex + 1 : currentScrollLeftIndex - 1;
      if (direction === "right") {
        nextScrollIndex = Math.min(nextScrollIndex, children.length - 1);
      } else {
        nextScrollIndex = Math.max(nextScrollIndex, 0);
      }
      const nextElement = children[nextScrollIndex];
      nextElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: direction === "right" ? "end" : "start"
      });
    },
    [containerRef, elementsRef]
  );
  return {
    scrollTo
  };
};
const getVisibleIndices = (container, elements) => {
  const indices = [];
  const containerWidth = container.offsetWidth;
  const containerScrollWidth = container.scrollWidth;
  const containerScrollLeft = container.scrollLeft;
  elements.forEach((element, index) => {
    if (!element) {
      return;
    }
    if (containerWidth === containerScrollWidth) {
      indices.push(index);
      return;
    }
    const elementWidth = element.offsetWidth;
    const elementOffset = element.offsetLeft;
    if (elementOffset + elementWidth <= containerScrollLeft || // hidden behind left scroll
    elementOffset > containerScrollLeft + containerWidth) {
      return;
    }
    indices.push(index);
  });
  return indices;
};
export {
  useHorizontalScroll
};
